module.exports = __webpack_public_path__ + "./images/306476ebca20f186b96ef6ca1cabe5a5.webp";